import React from 'react';
import FormDatePicker from '@shared/components/form/FormDatePicker';
import FormOrgUnitSelector from '@shared/components/form/FormOrgUnitSelector';
import FormInputFile from '@shared/components/form/FormInputFile';
import { FILE_TYPES } from '@shared/constants/fileTypes';
import LegalDocumentValidator from '../validators/LegalDocumentValidator';
import { showSuccessToast } from '@shared/services/toastService';

const FIELD_NAMES = {
  ORG_UNIT_IDS: 'orgUnitIds',
  COMPLETED_DATE: 'completedDate',
  FILE: 'file'
};

/**
 * @typedef {object} LegalDocumentInputFieldsProps
 * @property {Object} [organization]
 */

/**
 * @param {LegalDocumentInputFieldsProps} props
 */
const LegalDocumentInputFields = props => {
  const { organization } = props;
  const validateUploadedFile = file => {
    const { error } = LegalDocumentValidator.fileSchema.validate({
      type: file.type,
      size: file.size
    });

    return error;
  };

  return (
    <div className='legal-documents-form-fields'>
      <div className='input-container'>
        <div className='label-area'>
          <div className='label bold'>Org Unit</div>
        </div>

        <div className='legal-documents-input'>
          <FormOrgUnitSelector
            name={FIELD_NAMES.ORG_UNIT_IDS}
            id='org-unit-selector'
            organizations={organization ? [organization] : []}
          />
        </div>
      </div>

      <div className='input-container'>
        <div className='label-area'>
          <div className='label bold'>Completed Date</div>
        </div>

        <div className='legal-documents-input'>
          <FormDatePicker name={FIELD_NAMES.COMPLETED_DATE} id='date-picker' />
        </div>
      </div>

      <div className='input-container'>
        <div className='label-area'>
          <div className='label bold'>Upload Document</div>
        </div>

        <div className='legal-documents-input file-upload'>
          <FormInputFile
            name={FIELD_NAMES.FILE}
            id='file-upload'
            acceptedFileTypes={[FILE_TYPES.PDF]}
            validateFile={validateUploadedFile}
            data-testid='file-upload-input'
            onRemoveFile={() => {
              showSuccessToast('File successfully removed. Please upload a new file.');
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LegalDocumentInputFields;
